<template>
  <div>
    <lk-table :columns='columns' :data='row.assertsCuringHistoryVOs' class="mytable"/>
  </div>
</template>
<script>
export default {
  props: {
    row: Object,
  },
  mounted() {
    // console.log(this.row);
  },
  data() {
    return {
      columns: [
        {
          title: '设备编码',
          minWidth: 116,
          key: 'assertsCode',
          render: (h, { row }) => {
            let content = '';
            if (!row.assertsCode) {
              content = '-';
            } else {
              content = row.assertsCode;
            }
            return h('div', content);
          },
        },
        {
          title: '设备名称',
          minWidth: 116,
          key: 'assertsName',
          render: (h, { row }) => {
            let content = '';
            if (!row.assertsName) {
              content = '-';
            } else {
              content = row.assertsName;
            }
            return h('div', content);
          },
        },
        {
          title: '型号',
          minWidth: 116,
          key: 'unitType',
          render: (h, { row }) => {
            let content = '';
            if (!row.unitType) {
              content = '-';
            } else {
              content = row.unitType;
            }
            return h('div', content);
          },
        },
        {
          title: '生产厂家',
          minWidth: 116,
          key: 'manufacturer',
          render: (h, { row }) => {
            let content = '';
            if (!row.manufacturer) {
              content = '-';
            } else {
              content = row.manufacturer;
            }
            return h('div', content);
          },
        },
        {
          title: '养护内容',
          minWidth: 116,
          key: 'curingContent',
          render: (h, { row }) => {
            let content = '';
            if (!row.curingContent) {
              content = '-';
            } else {
              content = row.curingContent;
            }
            return h('div', content);
          },
        },
        {
          title: '养护结果',
          key: 'curingResult',
          minWidth: 116,
          render: (h, { row }) => {
            let content = '';
            if (!row.curingResult) {
              content = '-';
            } else {
              content = row.curingResult;
            }
            return h('div', content);
          },
        },
      ],
    };
  },
};
</script>
<style lang="less" scoped>

</style>
